// extracted by mini-css-extract-plugin
export default {"alertContainer":"DowntimeAlert__alertContainer___lntec","alertText":"DowntimeAlert__alertText___q3L3s"};